import { useCallback, useEffect, useState } from 'react'
import { fetchCsDashboard, type CsDashboardData } from '@/services/csService'

export function useCsDashboard() {
  const [data, setData] = useState<CsDashboardData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const load = useCallback(async () => {
    setLoading(true)
    setError('')
    try {
      setData(await fetchCsDashboard())
    } catch {
      setError('Não foi possível carregar o dashboard CS.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { data, loading, error, reload: load }
}
